<template>
  <v-col md="4">
    <v-card class="neu-glow">
      <v-row class="mx-0 pa-4" justify="space-between" align="center">
        <!-- title and subtitle -->
        <div>
          <div class="text-h6 float-left mr-1" v-text="$t('Dashboard.headingOperational')"></div>
          <div class="text-h6 float-left">: {{this.user.d_charts.ProfitsTot[0]}}</div>
        </div>
        <!-- Stats -->
        <div class="d-flex flex-column align-end">
          <v-bottom-navigation
            v-model="showingTasks"
            color="secondary"
            class="neu-glow with-radius"
            height="40"
          >
            <v-btn value="View All" to='./reports/profit_loss'>
              <span v-text="$t('Dashboard.viewAll')"></span>
            </v-btn>
          </v-bottom-navigation>
        </div>
      </v-row>
      <v-card-text class="py-0">
        <line-chart v-if="data"
            :data="buildChart"
            :options="option"
            :style="{ height: '300px' }"
            class="pt-5"
            id='Chart'
        />
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import colors from "vuetify/lib/util/colors";
import LineChart from "@/components/ChartJS/LineChart";
export default {
  components: { LineChart },
  computed : {
    ...mapGetters(["user"],["chartoptions"]),
    formattedTimeframe: function ()
    {
      let rsp='', options = {  day: '2-digit', month: 'short' };
      let prcs=this.user.timeframe;
      prcs.forEach(element => rsp+=(new Date(element).toLocaleDateString(this.user.locale || 'en', options).split('T')[0]+ ' - '));
      return rsp.slice(0, -3);
    },
    buildChart(){
      this.data.labels = this.user.d_charts.labels_chart;
      this.data.datasets=[];
      let charts=['Profits'];
      charts.forEach( e =>
      {                  
        if (this.user.d_charts[e])
        {
          if (this.user.d_charts[e].reduce((a, b) => a + b, 0)>0) 
          {
            let lc={"Profits":[colors.mygreen.lighten2, colors.mygreen.lighten2],"Sales":[colors.red.base, colors.red.accent3],"walmart":[colors.blue.base, colors.blue.accent3],"rakuten":[colors.orange.base, colors.orange.accent4],"total":[colors.red.base, colors.red.accent4]};
            this.empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
            this.empty_dataset.data = this.user.d_charts[e];
            this.empty_dataset.gradientStroke= lc[e];
            this.data.datasets.push(JSON.parse(JSON.stringify(this.empty_dataset)));
            //datasetscount++
          }
        }
      });
      return this.data;
    },
  },
  data() {
    return {
      namespace: "Dashboard",
      page: "Dashboard",
      loading:false,
      timeframe_dialog: false,
      errorid: null,
      search: '',
      showingTasks: "View All",
      orders: null,
      enabled_eBayAccounts: [],
      totalrevenue: null,
      empty_dataset:
      {
        label: '',
        yAxisID:1,
        fill: false,
        data: null,
        shadowOffsetX: 3,
        shadowOffsetY: 3,
        shadowBlur: 10,
        shadowColor: "rgba(103, 116, 132, 0.5)",
        pointRadius: 4,
        pointBevelWidth: 3,
        pointHoverRadius: 6,
        pointHoverBevelWidth: 4.5,
        pointHoverInnerGlowWidth: 20,
        pointHoverInnerGlowColor: `rgba(103, 116, 132, 0.5)`,
        gradientStroke: [colors.mygreen.darken2, colors.mygreen.darken2],

      },
      data: 
      {
        labels: null,
        datasets: null
      },
      option: 
      {
        responsive: true,
        scaleOverride: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: "nearest",
          backgroundColor:'rgba(255,255,255,0.85)',
          titleFontColor:'#333',
          bodyFontColor: '#333',
          xPadding:15,
          yPadding:15,
          intersect: true,
        },
        hover: {
          mode: "nearest",
          intersect: false,
        },
        legend: {
          display: true,
          position:'bottom',
          align: 'start',
          labels:{
            boxWidth: 5,
            usePointStyle: true
          },
          intersect: false,
        },
        layout: {
          padding: {
            left: 10,
            right: 10,
            bottom: 10,
            top: 10,
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true,
              },
              zeroLineWidth: 1,
            }
          ],
          yAxes: [
            {
             id:1,
             position: 'left',
             display: true,
             zeroLineWidth: 1,
             scalePositionLeft: true,
             ticks: {
                beginAtZero: true
              },
              gridLines: {
                offsetGridLines: false,
                zeroLineColor: '#ff0000',
              }
            },
          ]
        }
      },  
    };
  },
  created(){
		var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth();
    var d = date.getDate();
    var k = new Date(y,m,0).getDate();
    var firstDay = new Date(y, m, d-k+1);
    var lastDay = new Date(y, m , d+1);
    this.user.timeframe=[firstDay.toISOString().split('T')[0],lastDay.toISOString().split('T')[0]];
    //this.loadData()
  },
  methods:
  {
    changed_dateselector(){
      //console.log(this.user.timeframe);
      if (this.user.timeframe[0]>this.user.timeframe[1])
      {
        let tmp=this.user.timeframe[0];
        this.user.timeframe[0]=this.user.timeframe[1]
        this.user.timeframe[1]=tmp;
      }
      //this.loadData();
    },
    beforeDestroy() {
      this.chartProperties = null;
      delete this.chartProperties;
    },
  }
}
</script>